// @flow
import axios from 'lib/defaultClient';
import queryString from 'query-string';

export type WriteBannerPayload = {
  title: string,
  body: string,
  is_temp: boolean,
  tags: Array<string>,
  categories: Array<string>,
  thumbnail: ?string,
  url_slug?: ?string,
  is_private: boolean,
  series_id: ?string,
};

export const writeBanner = (payload: WriteBannerPayload) => axios.post('/banners', payload);

export type UpdateBannerPayload = {
  id: string,
  title: string,
  body: string,
  tags: Array<string>,
  categories: Array<string>,
  url_slug?: ?string,
  thumbnail?: string,
  is_temp: boolean,
  thumbnail: ?string,
  is_private: boolean,
  series_id: ?string,
};

export const updateBanner = ({ id, ...payload }: UpdateBannerPayload) =>
  axios.patch(`/banners/${id}`, payload);

export type ReadBannerPayload = {
  username: string,
  urlSlug: string,
};

export const readBanner = ({ username, urlSlug }: ReadBannerPayload) =>
  axios.get(`/banners/@${username}/${urlSlug}`);

export type UploadImagePayload = {
  file: any,
  bannerId: string,
  onUploadProgress(): void,
};

export const uploadImage = ({ file, bannerId, onUploadProgress }: UploadImagePayload) => {
  const data = new FormData();
  data.append('banner_id', bannerId);
  data.append('image', file);
  return axios.post('/files/upload/banner', data, {
    onUploadProgress,
  });
};

export type TempSavePayload = {
  title: string,
  body: string,
  bannerId: string,
};

export const tempSave = ({ bannerId, title, body }: TempSavePayload) =>
  axios.post(`/banners/${bannerId}/saves`, { title, body });

export type CreateUploadUrlPayload = { bannerId: string, filename: string };
export const createUploadUrl = ({ bannerId, filename }: CreateUploadUrlPayload) => {
  return axios.post('/files/create-url/banner-image', { banner_id: bannerId, filename });
};

/* LISTING RELATED... */
export const getPublicBanners = (cursor: ?string, category: ?string, sort: ?string) => {
  return axios.get('/banners/public', {
    params: {
      cursor,
      category,
      sort,
    },
  });
};

export const getTrendingBanners = (offset: ?number) => {
  const query = offset ? `?offset=${offset}` : '';
  return axios.get(`/banners/trending${query}`);
};

export type GetUserBannersPayload = {
  username: string,
  tag?: string,
  cursor?: string,
};

export const getUserBanners = ({ username, cursor, tag }: GetUserBannersPayload) => {
  const query = queryString.stringify({
    cursor,
    tag,
  });
  return axios.get(`/banners/@${username}?${query}`);
};

export type GetPublicBannersByCategoryPayload = {
  category: string,
  cursor?: string,
  sort?: string,
};

export const getPublicBannersByCategory = (payload: GetPublicBannersByCategoryPayload) => {
  const query = queryString.stringify(payload);
  return axios.get(`/banners/public?${query}`);
};

export type GetPublicBannersByTagPayload = {
  tag: string,
  cursor?: string,
};

export const getPublicBannersByTag = (payload: GetPublicBannersByTagPayload) => {
  const query = queryString.stringify(payload);
  return axios.get(`/banners/public?${query}`);
};

export type GetTempBannersPayload = {
  username: string,
  cursor?: string,
};

export const getTempBanners = ({ username, cursor }: GetTempBannersPayload) => {
  const query = queryString.stringify({
    is_temp: true,
    cursor,
  });
  return axios.get(`/banners/@${username}?${query}`);
};

export const deleteBanner = (bannerId: string) => {
  return axios.delete(`/banners/${bannerId}`);
};

export const getBannerById = (bannerId: string) => {
  return axios.get(`/banners/${bannerId}`);
};

export const getBannerSequences = (bannerId: string) => {
  return axios.get(`/banners/sequences?banner_id=${bannerId}`);
};



// WEBPACK FOOTER //
// ./src/lib/api/banners/index.js